module.exports = __webpack_public_path__ + "static/img/4.4c119b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/zh/4.png
// module id = aNK7
// module chunks = 0